import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import {
  formatInteger,
  formatPercent,
  impactTone,
  weatherScoreTone,
} from './weatherEventAnalyticsUtils'

function MetricCard({ title, value, subtitle, tone = 'neutral' }) {
  return (
    <Card
      body
      className={`card--xs card-with-border weather-metric-card weather-metric-card--${tone}`}
    >
      <p className="weather-metric-card__label">{title}</p>
      <p className="weather-metric-card__value">{value}</p>
      {subtitle ? (
        <p
          className={`weather-metric-card__subtitle weather-metric-card__subtitle--${tone}`}
        >
          {subtitle}
        </p>
      ) : null}
    </Card>
  )
}

export default function WeatherEventAnalyticsSummary({ analytics }) {
  if (!analytics) return null

  const weatherTone = weatherScoreTone(analytics.weatherScore)

  return (
    <div className="weather-event-analytics-summary">
      <h2 className="h5 mb-3">Weather impact overview</h2>
      <Row className="g-3">
        <Col sm={6} xl={4}>
          <MetricCard
            title="Weather severity score"
            value={formatInteger(analytics.weatherScore)}
            subtitle={
              analytics.weather?.conditionText ||
              '0 = severe, 100 = ideal conditions'
            }
            tone={weatherTone}
          />
        </Col>
        <Col sm={6} xl={4}>
          <MetricCard
            title="Attendance impact"
            value={formatPercent(analytics.attendanceImpactPct)}
            subtitle={`Expected ${formatInteger(analytics.benchmark?.expected_attendance)} · Actual ${formatInteger(analytics.actual?.attendance)}`}
            tone={impactTone(analytics.attendanceImpactPct)}
          />
        </Col>
        <Col sm={6} xl={4}>
          <MetricCard
            title="Walk-up sales impact"
            value={formatPercent(analytics.walkupSalesImpactPct)}
            subtitle={`Expected ${formatInteger(analytics.benchmark?.expected_walkup_sales)} · Actual ${formatInteger(analytics.actual?.walkupTickets)}`}
            tone={impactTone(analytics.walkupSalesImpactPct)}
          />
        </Col>
        <Col sm={6} xl={4}>
          <MetricCard
            title="Scan rate impact"
            value={formatPercent(analytics.scanRateImpactPct)}
            subtitle={`Expected ${formatPercent(analytics.benchmark?.expected_scan_rate, { signed: false })} · Actual ${formatPercent(analytics.actual?.scanRate, { signed: false })}`}
            tone={impactTone(analytics.scanRateImpactPct)}
          />
        </Col>
        <Col sm={6} xl={4}>
          <MetricCard
            title="Parking impact"
            value={formatPercent(analytics.parkingImpactPct)}
            subtitle="Based on attendance-linked parking revenue proxy"
            tone={impactTone(analytics.parkingImpactPct)}
          />
        </Col>
        <Col sm={6} xl={4}>
          <MetricCard
            title="Staffing adjustment"
            value={formatPercent(analytics.staffingAdjustmentPct)}
            subtitle={`Forecast ${formatInteger(analytics.staffing?.forecastAttendance)} fans`}
            tone={impactTone(analytics.staffingAdjustmentPct)}
          />
        </Col>
      </Row>
    </div>
  )
}
